/* Uit sections/casanuva-collection-v2.liquid gehaald. Draait met defer: na het parsen, dus de elementen
   die deze code opzoekt bestaan gegarandeerd. Alles zit in een IIFE,
   dus er lekt niets naar de global scope. */

(function() {
  'use strict';

  // De vertaalde zin komt als data-attribuut mee; @N@ en @T@ zijn de plekken
  // waar de getallen in horen. Geen terugval op Engels: een lege vertaling is
  // een geldige vertaling.
  function cnvStatusTekst(el, getoond, totaal) {
    var patroon = el && el.getAttribute('data-patroon');
    if (patroon === null || patroon === undefined) return '';
    return patroon.replace('@N@', getoond).replace('@T@', totaal);
  }


  /* ========== SORT DROPDOWN ========== */
  var sortBtn = document.getElementById('cnv-col-sort-btn');
  var sortDrop = document.getElementById('cnv-col-sort-drop');

  if (sortBtn && sortDrop) {
    sortBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      sortDrop.classList.toggle('is-open');
    });
    document.addEventListener('click', function(e) {
      if (!sortDrop.contains(e.target) && e.target !== sortBtn) {
        sortDrop.classList.remove('is-open');
      }
    });
  }

  /* ========== FILTER DRAWER ========== */
  var filterBtn = document.getElementById('cnv-col-filter-btn');
  var drawer = document.getElementById('cnv-col-drawer');
  var overlay = document.getElementById('cnv-col-overlay');
  var drawerClose = document.getElementById('cnv-col-drawer-close');
  var clearBtn = document.getElementById('cnv-col-filter-clear');
  var applyBtn = document.getElementById('cnv-col-filter-apply');

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (filterBtn) filterBtn.addEventListener('click', openDrawer);
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  /* ========== FILTER GROUP TOGGLE ========== */
  document.querySelectorAll('[data-toggle-group]').forEach(function(head) {
    head.addEventListener('click', function() {
      this.closest('.cnv-col__fgroup').classList.toggle('is-collapsed');
    });
  });

  /* ========== COLOR SWATCH TOGGLE ========== */
  document.querySelectorAll('.cnv-col__fswatch').forEach(function(sw) {
    sw.addEventListener('click', function() {
      this.classList.toggle('active');
    });
  });

  /* ========== CLEAR ALL FILTERS ========== */
  if (clearBtn) {
    clearBtn.addEventListener('click', function() {
      /* Clear colors */
      document.querySelectorAll('.cnv-col__fswatch.active').forEach(function(s) {
        s.classList.remove('active');
      });
      /* Clear checkboxes */
      document.querySelectorAll('.cnv-col__drawer input[type="checkbox"]').forEach(function(cb) {
        cb.checked = false;
      });
      /* Clear price */
      var pmin = document.getElementById('cnv-filter-price-min');
      var pmax = document.getElementById('cnv-filter-price-max');
      if (pmin) pmin.value = '';
      if (pmax) pmax.value = '';
      /* Show all cards */
      document.querySelectorAll('#cnv-col-grid .cnv-card').forEach(function(card) {
        card.style.display = '';
      });
      updateFilterCount();
      closeDrawer();
    });
  }

  /* ========== APPLY FILTERS ========== */
  if (applyBtn) {
    applyBtn.addEventListener('click', function() {
      applyFilters();
      closeDrawer();
    });
  }

  function applyFilters() {
    /* Gather active colors */
    var activeColors = [];
    document.querySelectorAll('.cnv-col__fswatch.active').forEach(function(s) {
      activeColors.push(s.getAttribute('data-color'));
    });

    /* Gather checked materials */
    var activeMaterials = [];
    document.querySelectorAll('input[name="filter-material"]:checked').forEach(function(cb) {
      activeMaterials.push(cb.value);
    });

    /* Gather checked styles */
    var activeStyles = [];
    document.querySelectorAll('input[name="filter-style"]:checked').forEach(function(cb) {
      activeStyles.push(cb.value);
    });

    /* Price range */
    var priceMin = parseFloat(document.getElementById('cnv-filter-price-min') ? document.getElementById('cnv-filter-price-min').value : '') || 0;
    var priceMax = parseFloat(document.getElementById('cnv-filter-price-max') ? document.getElementById('cnv-filter-price-max').value : '') || Infinity;

    var hasFilters = activeColors.length > 0 || activeMaterials.length > 0 || activeStyles.length > 0 || priceMin > 0 || priceMax < Infinity;

    var cards = document.querySelectorAll('#cnv-col-grid .cnv-card');
    var visibleCount = 0;

    cards.forEach(function(card) {
      if (!hasFilters) {
        card.style.display = '';
        visibleCount++;
        return;
      }

      var tags = (card.getAttribute('data-tags') || '').toLowerCase();
      var priceStr = (card.getAttribute('data-price') || '0').replace(/[^0-9.,]/g, '').replace(',', '.');
      var price = parseFloat(priceStr) || 0;

      var show = true;

      /* Color filter — OR logic */
      if (activeColors.length > 0) {
        var colorMatch = false;
        for (var i = 0; i < activeColors.length; i++) {
          if (tags.indexOf('color:' + activeColors[i]) !== -1) {
            colorMatch = true;
            break;
          }
        }
        if (!colorMatch) show = false;
      }

      /* Material filter — OR logic */
      if (show && activeMaterials.length > 0) {
        var matMatch = false;
        for (var i = 0; i < activeMaterials.length; i++) {
          if (tags.indexOf('material:' + activeMaterials[i]) !== -1) {
            matMatch = true;
            break;
          }
        }
        if (!matMatch) show = false;
      }

      /* Style filter — OR logic */
      if (show && activeStyles.length > 0) {
        var styMatch = false;
        for (var i = 0; i < activeStyles.length; i++) {
          if (tags.indexOf('style:' + activeStyles[i]) !== -1) {
            styMatch = true;
            break;
          }
        }
        if (!styMatch) show = false;
      }

      /* Price filter */
      if (show && (price < priceMin || price > priceMax)) {
        show = false;
      }

      card.style.display = show ? '' : 'none';
      if (show) visibleCount++;
    });

    updateFilterCount();
  }

  function updateFilterCount() {
    var visible = document.querySelectorAll('#cnv-col-grid .cnv-card:not([style*="display: none"])').length;
    var total = document.querySelectorAll('#cnv-col-grid .cnv-card').length;
    var status = document.getElementById('cnv-col-loadmore-status');
    if (status) {
      status.textContent = cnvStatusTekst(status, visible, total);
    }
    var applyText = document.getElementById('cnv-col-filter-apply');
    if (applyText) {
      applyText.textContent = 'Show Results (' + visible + ')';
    }
  }

  /* ========== LOAD MORE ========== */
  var loadMoreBtn = document.getElementById('cnv-col-loadmore-btn');
  var grid = document.getElementById('cnv-col-grid');

  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function() {
      var nextUrl = this.getAttribute('data-next-url');
      if (!nextUrl) return;

      this.disabled = true;
      this.textContent = 'Loading...';

      fetch(nextUrl)
        .then(function(res) { return res.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newCards = doc.querySelectorAll('#cnv-col-grid .cnv-card');
          var newLoadMore = doc.getElementById('cnv-col-loadmore-btn');

          newCards.forEach(function(card) {
            grid.appendChild(card);
          });

          if (newLoadMore) {
            loadMoreBtn.setAttribute('data-next-url', newLoadMore.getAttribute('data-next-url'));
            loadMoreBtn.disabled = false;
            loadMoreBtn.textContent = loadMoreBtn.getAttribute('data-label') || '';
          } else {
            loadMoreBtn.remove();
          }

          /* Update status */
          var totalLoaded = grid.querySelectorAll('.cnv-card').length;
          var statusEl = document.getElementById('cnv-col-loadmore-status');
          var totalProducts = parseInt((statusEl && statusEl.getAttribute('data-totaal')) || '0', 10);
          if (statusEl) {
            statusEl.textContent = cnvStatusTekst(statusEl, totalLoaded, totalProducts);
          }

          /* Update toolbar info */
          var toolbarInfo = document.getElementById('cnv-col-toolbar-info');
          if (toolbarInfo) {
            toolbarInfo.textContent = cnvStatusTekst(toolbarInfo, totalLoaded, totalProducts);
          }
        })
        .catch(function() {
          loadMoreBtn.disabled = false;
          loadMoreBtn.textContent = loadMoreBtn.getAttribute('data-label') || '';
        });
    });
  }

})();
